import React, { useState, useRef } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack5";
import styled from "styled-components";
import * as pdfjs from "pdfjs-dist";
import { pdfjsWorker } from "pdfjs-dist/webpack";
import { useNavigate } from "react-router-dom";
import fetchWithToken from "../../fetchWithToken";
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';

const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@3.4.120/build/pdf.worker.min.js`
pdfjs.GlobalWorkerOptions.workerSrc = url

const NewChatCard = () => {
    const navigate = useNavigate();

    const [file, setFile] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [fileName, setFileName] = useState("");
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState("");
    const [errorLoadingPdf, setErrorLoadingPdf] = useState(false);

    const MAX_PAGES = 75;
    const pageNumber = 1;

    const onFileChange = (event) => {
        const selectedFile = event.target.files[0];
        const fileName = selectedFile.name;
        setFileName(fileName);
        setFile(selectedFile);
        setErrorLoadingPdf(false); // Reset the error state
        parsePdfContent(selectedFile);
    };
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const StyledPage = styled(Page)`
  .react-pdf__Page__canvas {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%
    object-fit: contain;
  }
`;

    const fileInputRef = useRef(null);
    const handleBackButtonClick = () => {
        setFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setNumPages(null);
    };

    const parsePdfContent = async (file) => {
        try {
            const pdf = await pdfjs.getDocument({ url: URL.createObjectURL(file) }).promise;
            let content = '';

            for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
                const page = await pdf.getPage(pageNumber);
                const textContent = await page.getTextContent();

                content += textContent.items.map(item => item.str).join(' ') + ' ';
            }

            const trimmedContent = content.replace(/\s+/g, ' ').trim();
            setContent(trimmedContent);
        } catch (error) {
            console.error('Error parsing PDF content:', error);
        }
    };

    const handleCreateChat = async () => {
        if (numPages > MAX_PAGES) {
            toast.error("Your PDF has too many pages. The max pages is " + MAX_PAGES + ".")
        } else if (content === "") {
            toast.error("Sorry, we couldn't find any content in your PDF.")
        } else {
            setLoading(true)

            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json", ...axios.defaults.headers },
                body: JSON.stringify({
                    fileName: fileName,
                    imageUrl: "https://blog.idrsolutions.com/app/uploads/2020/10/pdf-1.png",
                    settings: {},
                    content: content,
                }),
            };

            try {
                const response = await toast.promise(
                    fetchWithToken('/api/chat', requestOptions).then((res) => {
                        if (!res.ok) {
                            throw new Error("Request failed with status " + res.status);
                        }
                        return res;
                    }),
                    {
                        loading: 'Create a fresh new chat for you!',
                        success: 'Yay, welcome to your new chat 🥳',
                        error: 'Hmm, looks like there may be an issue with that PDF.'
                    }
                );

                const responseData = await response.json();
                navigate(responseData.path);
            } catch (error) {
                console.error('Error:', error);
                toast.error('Hmm, looks like there may be an issue with that PDF.');
            } finally {
                setLoading(false);
            }
        }
    }

    const setPDFErr = (err) => {
        console.log(err);
        setErrorLoadingPdf(true);
    };

    return (
        <div className="my-auto card w-96 h-[90%] m-10 bg-base-100 shadow-xl">
            {file ? (
                <figure className="px-1 pt-1 relative">
                    <div className="relative h-48 w-full m-auto">
                        {errorLoadingPdf ? (
                            <img
                                src="https://blog.idrsolutions.com/app/uploads/2020/10/pdf-1.png"
                                alt="PDF Image"
                                className="m-auto"
                                style={{ width: "80%", height: "80%", objectFit: "contain" }}
                            />
                        ) : (
                            <Document file={file} className="text-center" onLoadSuccess={onDocumentLoadSuccess} onLoadError={setPDFErr}>
                                <StyledPage
                                    className="m-auto"
                                    pageNumber={pageNumber}
                                    height={250}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                />
                            </Document>
                        )}
                    </div>
                </figure>
            ) : (
                <div className="card-body items-center text-center">
                    <h2 className="card-title text-md">Create PDF Chatbot</h2>
                    <p>
                        Upload a PDF to create a new Chat that will learn and reference the
                        text!
                    </p>
                </div>
            )
            }
            <div className="form-control w-[75%] mb-2 mx-auto max-w-xs">
                <label className="label">
                    {numPages && (
                        <span className="label-text-alt">Pages: {numPages}</span>
                    )}
                    <span className="label-text-alt">Max Pages: {MAX_PAGES}</span>
                </label>
                <input
                    ref={fileInputRef}
                    accept=".pdf"
                    type="file"
                    className="file-input file-input-bordered w-full max-w-xs"
                    onChange={onFileChange}
                />
                {
                    file && (
                        <div className="m-auto flex justify-between w-full">
                            <div onClick={handleBackButtonClick} className="btn w-20 md:w-28 my-5 btn-outline button-fixed-width">Back</div>
                            <div
                                className={`btn w-20 md:w-28 my-5 button-fixed-width ${file
                                    ? "btn "
                                    : "btn btn-disabled"
                                    } ${loading ? 'loading' : ''}`}
                                onClick={handleCreateChat}
                            >
                                Create
                            </div>
                        </div>
                    )
                }
            </div>
            <Toaster
                position="top-center"
                reverseOrder={false}
            />
        </div >
    );
};

export default NewChatCard;
